// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // dataUrl: 'http://localhost:9886/',
  dataUrl: 'https://uat.predictscreen.com/',
  dvDataUrl: 'https://qa2-app.dvapply.com/',
  // dvDataUrl: 'http://localhost:3000/',
  googleMapsApiKey: 'AIzaSyAQ59nHdSJ91t6wkF0KcgsgCpn3xr-j1iU'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
